import { useCachedNumberFormat } from "@plansoft-configuration-renderer/utils";
import { useConfigurationLanguage } from "./useConfigurationLanguage";
/**
 * Returns a {@linkcode Intl.NumberFormatOptions} object using the current locale
 * @category Hook
 * @param options
 * @returns
 */
export function useNumberFormat(options) {
    const localeCode = useConfigurationLanguage();
    return useCachedNumberFormat(localeCode, options);
}
//# sourceMappingURL=useNumberFormat.js.map